<template>
    <div class="content">
      <h1>Ninja Legend</h1>
      <p>Placeholder.</p>
    </div>

</template>


